export default __webpack_public_path__ + "static/media/BR.26bbe539.svg";